<!--<div id="chart_div" class="dragscroll"></div>-->
<div #chartContainer id="chartContainer"></div>
